var React = require('react');

function Ddp (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".st0{fill:#ff366b}.st1{fill:#f5ff31}.st2{fill:#17a7ff}.st3{fill:currentColor}"),React.createElement("path",{"className":"st0","d":"M49.7 85.8h21.6V938H49.7z","key":1}),React.createElement("path",{"className":"st1","d":"M92.8 938H71.2l.1-852.2h21.5z","key":2}),React.createElement("path",{"className":"st2","d":"M115.4 938H92.8V85.8h22.6z","key":3}),React.createElement("path",{"className":"st3","d":"M115.5 85.8h852.2V938H115.5z","key":4})]);
}

Ddp.defaultProps = {"id":"Layer_3","viewBox":"0 0 1024 1024"};

module.exports = Ddp;

Ddp.default = Ddp;
